import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CartItem from "./CartItem";
import ClearCart from "./ClearCart";
import "../../styles/CartPage.css";
import {setTotalPrice, setStoreObj} from "../../utils/storage";
import StoreInfo from "../StoreInfo";
import {clearCart, getCart, removeFromCart} from "../../api/cartAPI";
import {getProductById} from "../../api/productsAPI";

const CartPage = () => {
    const navigate = useNavigate();
    // Состояния
    const [cart, setCart] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isCartEmpty, setIsCartEmpty] = useState(false);
    //const [totalOriginalPrice, setTotalOriginalPrice] = useState(0)
    const [notification, setNotification] = useState(""); // Для ошибок и уведомлений
    const [isModalOpen, setIsModalOpen] = useState(false); // Состояние для модального окна

    useEffect(() => {
        const fetchCart = async () => {
            try {
                const cartItems = await getCart();
                if (!cartItems || cartItems.length === 0) {
                    setIsCartEmpty(true);
                    setCart([]);
                    return;
                }

                // Загрузка продуктов из корзины
                const productPromises = cartItems.map((item) => getProductById(item));
                const products = await Promise.all(productPromises);
                setCart(products);
            } catch (error) {
                console.error("Error loading the cart:", error);
                setNotification("Failed to load cart data. Please try again.");
            } finally {
                setIsLoading(false);
            }
        };

        fetchCart();
    }, []);

    const handleRemoveItem = async (productId) => {
        try {
            await removeFromCart(productId);
            const updatedCart = cart.filter((item) => item.product_id !== productId);
            setCart(updatedCart);
            if (updatedCart.length === 0) {
                setStoreObj(null)
                setIsCartEmpty(true);
            }
        } catch (error) {
            console.error("Error removing item from the cart:", error);
            setNotification("Failed to remove the item. Please try again.");
        }
    };

    const handleClearCart = async () => {
        try {
            await clearCart();
            setCart([]);
            setIsCartEmpty(true);
            setStoreObj(null)
        } catch (error) {
            console.error("Error clearing the cart:", error);
            setNotification("Failed to clear the cart. Please try again.");
        }
        handleCloseModal();
    };

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const totalDiscountedPrice = cart.reduce((sum, item) => sum + parseFloat(item.discounted_price || 0), 0);
    const totalOriginalPrice = cart.reduce((sum, item) => sum + parseFloat(item.original_price || 0), 0);
    //TODO check that original price is reRednder
    //setTotalOriginalPrice(totalOrigPrice)
    setTotalPrice(totalDiscountedPrice);

    // Если идет загрузка данных
    if (isLoading) {
        return <p>Завантаження корзини...</p>;
    }

    return (
        <div className="cart-page">
        {isCartEmpty ? (
            <div className="empty-cart">
                <h1>Товарів у кошику: {cart.length}</h1>
                <div>
                    <img src="/images/empty-cart.svg" alt="empty_cart"/>
                    <p>Кошик наразі порожній</p>
                </div>
                <button
                    onClick={() => navigate('/')}
                    className="primary_button"
                    id="empty-cart-continue"
                >До покупок</button>
            </div>
        ) : (
            <>
            <h1>Товарів у кошику: {cart.length}</h1>
                <StoreInfo/>

                <div className="cart-items">
                    {cart.map((product) => (
                        <CartItem
                            key={product.product_id}
                            product={product}
                            onRemove={handleRemoveItem}
                        />
                    ))}
                </div>
                <button
                    onClick={handleOpenModal}
                    disabled={isCartEmpty}
                    className="cart-clear_button">
                    Очистити кошик
                </button>

                <div className="cart-divider"/>

                <button
                    onClick={() => navigate(-1)}
                    className="cart-continue_shopping">
                    Додати ще товари
                    <img src="/images/arrow-right.svg" alt='arrow_right'/>
                </button>

            {!isModalOpen && (
                <div className="cart-summary">
                    <div className="cart-summary__info">
                        <h3>Разом:</h3>
                        <div className="cart-summary__prices">
                            <p className="cart-summary__prices_orig">{totalOriginalPrice} ₴</p>
                            <p className="cart-summary__prices_disc">{totalDiscountedPrice} ₴</p>
                        </div>
                    </div>
                    <div className="cart-divider"/>
                    <button
                        id="cart-continue"
                        onClick={() => navigate("/order-setup")}
                        disabled={isCartEmpty}>
                        Продовжити
                    </button>
                </div> )}
            </>
        )}

            {/* Модальное окно */}
            {isModalOpen && (
                <>
                <div
                    id="overlay"
                    onClick={handleCloseModal}
                ></div>
                <ClearCart
                    onClear={handleClearCart}
                    onClose={handleCloseModal}
                />
                </>
            )}

            {/* Уведомления об ошибках */}
            {notification && (
                <div className="notification error">
                    <p>{notification}</p>
                </div>
            )}
        </div>
    );
};

export default CartPage;
